import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';

const StyledButton = styled.button`
  padding: ${theme.spacing.md} ${theme.spacing.xl};
  border-radius: ${theme.borderRadius.md};
  font-size: ${theme.typography.fontSize.base};
  font-weight: ${theme.typography.fontWeight.medium};
  font-family: ${theme.typography.fontFamily.sans.join(', ')};
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  position: relative;
  overflow: hidden;
  
  ${props => props.variant === 'primary' && `
    background: ${theme.gradients.primary};
    color: ${theme.colors.white};
    box-shadow: ${theme.shadows.md};
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: ${theme.shadows.lg};
    }
    
    &:active {
      transform: translateY(0);
    }
  `}
  
  ${props => props.variant === 'secondary' && `
    background: ${theme.colors.white};
    color: ${theme.colors.primary[700]};
    border: 2px solid ${theme.colors.primary[200]};
    
    &:hover {
      background: ${theme.colors.primary[50]};
      border-color: ${theme.colors.primary[300]};
      transform: translateY(-2px);
    }
  `}
  
  ${props => props.variant === 'outline' && `
    background: transparent;
    color: ${theme.colors.primary[600]};
    border: 2px solid ${theme.colors.primary[600]};
    
    &:hover {
      background: ${theme.colors.primary[600]};
      color: ${theme.colors.white};
    }
  `}
  
  ${props => props.size === 'large' && `
    padding: ${theme.spacing.lg} ${theme.spacing['2xl']};
    font-size: ${theme.typography.fontSize.lg};
  `}
  
  ${props => props.size === 'small' && `
    padding: ${theme.spacing.sm} ${theme.spacing.md};
    font-size: ${theme.typography.fontSize.sm};
  `}
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
  }
`;

export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'medium',
  ...props 
}) {
  return (
    <StyledButton variant={variant} size={size} {...props}>
      {children}
    </StyledButton>
  );
}